/**
 * Convert seconds to HH:MM:SS.\
 * If seconds exceeds 24 hours, hours will be greater than 24 (30:05:10)
 * @param seconds Seconds to convert
 * @returns HH:MM:SS
 */
export const secondsToHms = (
	seconds: number,
	totalSeconds?: number,
): string => {
	const totalHours = totalSeconds ? Math.floor(totalSeconds / 3600) : null;
	const days = Math.floor(seconds / 86400);
	const remainderSeconds = seconds % 86400;
	const hms = new Date(remainderSeconds * 1000).toISOString().substring(11, 19);
	let str = hms.replace(/^(\d+)/, (h) =>
		`${Number(h) + days * 24}`.padStart(2, '0'),
	);

	if (totalSeconds != null && (!totalHours || totalHours < 1)) {
		str = str.replace(/^00:/, '');
	}

	return str;
};
